import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { Sidebar, MobileMenuButton } from './sidebar';
import { useProfile } from '@/lib/providers';
import Loading from '@/components/loading';
import { RestoreAccountScreen } from '@/components/profile/restore-account-screen';
import { LOGIN_PATH } from '@/lib/constants';

const isCapacitor = !!(window as any).Capacitor;

export function ProtectedLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, loadingProfile } = useProfile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Hide menu on player pages in Capacitor
  const isPlayerPage = isCapacitor && (
    /^\/meditaties\/[\w-]+$/.test(location.pathname) ||
    /^\/binaural-beat\/[\w-]+$/.test(location.pathname)
  );

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (!session) {
        navigate(LOGIN_PATH);
      }
    });
    return () => subscription.unsubscribe();
  }, [navigate]);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  if (loadingProfile) return <Loading />;

  if (profile?.deleted_at) {
    return <RestoreAccountScreen deletedAt={profile.deleted_at} />;
  }

  if (!profile) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="text-center space-y-4">
          <h2 className="text-xl font-semibold">Account niet gevonden</h2>
          <p className="text-gray-600">
            Nieuwe gebruiker? Bevestig je e-mail en ververs de pagina.
          </p>
          <a
            href="/login?signup=1"
            className="inline-block px-4 py-2 bg-green-800 hover:bg-green-700 text-white rounded-full"
          >
            Of maak een account aan
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen">
      {!isPlayerPage && <MobileMenuButton onClick={() => setMobileMenuOpen(true)} />}
      <Sidebar isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      {/* Main content area with responsive padding */}
      <main className="flex-1 overflow-y-auto pt-16 lg:pt-0 cap-content">
        {children}
      </main>
    </div>
  );
}
